export default __webpack_public_path__ + "static/media/gridImg5.b2c02ea2.jpg";